// Hover Effect
$( ".Products_carousel_card" ).on( "mouseover", function() {
    $('.Products_carousel_card').removeClass('active');
    $(this).addClass('active');
} );
$( ".Products_carousel_card" ).on( "mouseout", function() {
    $('.Products_carousel_card').removeClass('active');
} );


$('.col_prod_btn_outer_more a').click(function(evt){
    evt.preventDefault();
    $(this).closest('.Main_coll_outer_full').find('.Collection_product_card').removeClass('hided_before_load')
    $(this).hide();
  });


// Bundle bought
function calculateBoughPrice(){
  var totalPrice = 0;
  var totalComparePrice = 0;

  $('.Bt_select_option_info').hide();
  $('.bought_together_summary').hide();

  if ($('.BT_cell.pagalve_upsell').hasClass('active')){
    $('.nr_bought_mask_sale_price').show();
    $('.nr_bought_other_price').hide();
  }
  else{
    $('.nr_bought_mask_sale_price').hide();
    $('.nr_bought_other_price').show();
  }
  $('.BT_cell.active').each(function(){
    var currentTotal = parseFloat($(this).find('.price_line.active').attr('data-price'));
    var currentcompareTotal = parseFloat($(this).find('.price_line.active').attr('data-compare'));
    if ($('.pagalve_upsell').hasClass('active')){
      if ($(this).hasClass('kauke_upsell')){
        currentTotal = currentTotal * 0.7;
      }
    }
    totalPrice = totalPrice + currentTotal;
    totalComparePrice = totalComparePrice + currentcompareTotal;
    var data = $(this).attr('data');
    $('.Bt_select_option_info[data="'+data+'"]').show();
    $('.bought_together_summary').show();
  });

  totalPrice = (totalPrice/100).toFixed(2);
  totalComparePrice = (totalComparePrice/100).toFixed(2);
  $('.Bough_together_products h4 span').html(totalPrice + ' €<s> '+totalComparePrice+' €</s>');
}

$('.BT_cell').click(function(){
  if (!$(event.target).closest('.BT_select_procuts').length) {
    $(this).toggleClass('active');
    calculateBoughPrice();
  }
});

$('.BT_select_procuts.Desktop_only').change(function(){
    var data = $(this).attr('data');
    var value = $(this).val()
    console.log(data, value);

    $('.BT_cell[data='+data+']').find('.BT_main_image').hide();
    $('.BT_cell[data='+data+']').find('.BT_main_image').each(function(){
        if($(this).attr('data-id') == value){
            $(this).show();
        }
    });

    $('.BT_cell[data='+data+']').find('.price_line').hide();
    $('.BT_cell[data='+data+']').find('.price_line').removeClass('active');
    $('.BT_cell[data='+data+']').find('.price_line').each(function(){
        if($(this).attr('data-id') == value){
            $(this).show();
            $(this).addClass('active');
        }
    });

    var total_sum = 0;
    var total_compare_sum = 0;
    var currency = '€';

    $('.BT_cell').each(function(){
        var currentPrice = $(this).find('.price_line.active').html();
        var current_Price = currentPrice.split('<s>');
        currentPrice = current_Price[0];
        var currentComparePrice = current_Price[1];
        currentPrice = parseFloat(currentPrice.replace('€', '').replace(',', '.'));
        currentComparePrice = parseFloat(currentComparePrice.replace('</s>').replace('€', '').replace(',', '.'));
        total_sum = total_sum + currentPrice;
        total_compare_sum = total_compare_sum + currentComparePrice;
    });
    total_sum = total_sum.toFixed(2);
    total_compare_sum = total_compare_sum.toFixed(2);
    $('.Bough_together_products h4 span').html(total_sum+' '+currency+' <s>'+total_compare_sum+' '+currency+'</s>');

    calculateBoughPrice();
});

$('.BT_select_procuts.Mobile_only').change(function(){
    var data = $(this).attr('data');
    var value = $(this).val()
    console.log(data, value);

    $('.BT_cell[data='+data+']').find('.BT_main_image').hide();
    $('.BT_cell[data='+data+']').find('.BT_main_image').each(function(){
        if($(this).attr('data-id') == value){
            $(this).show();
        }
    });

    $('.BT_cell[data='+data+']').find('.price_line').hide();
    $('.BT_cell[data='+data+']').find('.price_line').removeClass('active');
    $('.BT_cell[data='+data+']').find('.price_line').each(function(){
        if($(this).attr('data-id') == value){
            $(this).show();
            $(this).addClass('active');
        }
    });

    var total_sum = 0;
    var total_compare_sum = 0;
    var currency = '€';

    $('.BT_cell').each(function(){
        var currentPrice = $(this).find('.price_line.active').html();
        var current_Price = currentPrice.split('<s>');
        currentPrice = current_Price[0];
        var currentComparePrice = current_Price[1];
        currentPrice = parseFloat(currentPrice.replace('€', '').replace(',', '.'));
        currentComparePrice = parseFloat(currentComparePrice.replace('</s>').replace('€', '').replace(',', '.'));
        total_sum = total_sum + currentPrice;
        total_compare_sum = total_compare_sum + currentComparePrice;
    });
    total_sum = total_sum.toFixed(2);
    total_compare_sum = total_compare_sum.toFixed(2);
    $('.Bough_together_products h4 span').html(total_sum+' '+currency+' <s>'+total_compare_sum+' '+currency+'</s>');

    calculateBoughPrice();
});



document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

// Slick Carousel Enabling

$('.Products_carousel__js').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    centerMode: false,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Group_2524.png?v=1686900777'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Group_2523.png?v=1686900776'/></button>",
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          arrows: false
        }
      }
    ]
  });


function show_note() {
    var randomNumber = Math.floor(Math.random() * 13) + 1;
    console.log(randomNumber);

    $('.Product_notification.Desktop_only').each(function(){
        if($(this).attr('data-index') == randomNumber){
            $(this).css('bottom', '20px');
        }
    });
    $('.Product_notification.Mobile_only').each(function(){
        if($(this).attr('data-index') == randomNumber){
            $(this).css('top', '10px');
        }
    });

    setTimeout(function(){
        $('.Product_notification.Desktop_only').css('bottom', '-200px');
        $('.Product_notification.Mobile_only').css('top', '-200px');
    },4000);
}

 // setInterval(show_note, 15000);


// BF Influnecers specifically code
function setInfluencersCookies (){
    var currentLocation = String(window.location.href);
    if ( currentLocation.indexOf('lepafna_code') != -1){
        document.cookie = "influencer=Julia; expires=Thu, 1 Jan 2024 00:00:00 UTC; path=/";
    }
    if ( currentLocation.indexOf('naglis_kodas') != -1){
        document.cookie = "influencer=Naglis; expires=Thu, 1 Jan 2024 00:00:00 UTC; path=/";
    }
    if ( currentLocation.indexOf('ieva_kodas') != -1){
        document.cookie = "influencer=Ieva; expires=Thu, 1 Jan 2024 00:00:00 UTC; path=/";
    }
}

setInfluencersCookies();

function setUpInfluencerContent(){
    var cookies = document.cookie.split(';');
    var influencer = 'none';
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if (cookie.indexOf('influencer=Julia') === 0) {
        influencer = 'Julia';
      }
      if (cookie.indexOf('influencer=Naglis') === 0) {
        influencer = 'Naglis';
      }
      if (cookie.indexOf('influencer=Ieva') === 0) {
        influencer = 'Ieva';
      }
    }
    if ( influencer == 'Dalia'){
        // $('.Dalia_discount_code').show();
      $('.Classic_messaging').show();
    }
    else if ( influencer == 'Naglis'){
        // $('.Naglis_discount_code').show();
      $('.Classic_messaging').show();
    }
    else if ( influencer == 'Ieva'){
        // $('.Ieva_discount_code').show();
      $('.Classic_messaging').show();
    }
    else{
        $('.Classic_messaging').show();
    }
    console.log(influencer, 'INFLUENCER =========');
}

 setUpInfluencerContent();


document.addEventListener("contextmenu", function (e){
    e.preventDefault();
}, false);




$('.hm_products-carousel').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  centerMode: false,
  prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Icon_ionic-ios-arrow-dropright-1.png?v=1726128971'/></button>",
  nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Icon_ionic-ios-arrow-dropright_8f97daf1-6bb7-4dac-a6b7-e11dd3d4eef1.png?v=1726128970'/></button>",
  responsive: [
    {
      breakpoint: 678,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

$('.hm_reviews-carousel').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  centerMode: false,
  prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Icon_ionic-ios-arrow-dropright-1.png?v=1726128971'/></button>",
  nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Icon_ionic-ios-arrow-dropright_8f97daf1-6bb7-4dac-a6b7-e11dd3d4eef1.png?v=1726128970'/></button>",
  responsive: [
    {
      breakpoint: 678,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});